<div class="hb-card card">
    <div class="hb-card-header">
        <h1 class="hb-h3">
            Kartleggingen er avsluttet
        </h1>
    </div>
    <div class="hb-card-body card-content">
        <p>Kartleggingen er avsluttet, du kan starte en ny kartlegging når du vil.</p>
        <button hb-button [variant]="'PROMINENT'" (click)="tilBoligkompasset()">Gå tilbake til Boligkompasset
        </button>
    </div>
</div>
